import React from 'react'
import { IPermissionProps } from '@/types/shared'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { FilterBar } from '@/components/ui/data-table-customized'
import { Button } from 'vnetwork-ui'
import AddIcons from '@/icons/AddIcons'
import DownLoadIcons from '@/icons/DownLoadIcons'
import { useResumeList } from './use-resume-list'

/**
 * Resume List Component
 * Displays list of resumes with filtering, sorting, and actions
 */
const List: React.FC<IPermissionProps> = () => {
    const {
        resumes,
        pagination,
        stateComponent,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        actions,
        filterItems,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        handleCreateNew,
        handleManageJobs,
        handleExport,
        t,
    } = useResumeList()

    return (
        <div className="space-y-2" data-tour="resume-list">
            {/* Header with actions */}
            <SubHeaders
                actions={[
                    {
                        label: t('create'),
                        onClick: handleCreateNew,
                        variant: 'contained',
                        icon: <AddIcons />,
                        'data-tour': 'create-resume-btn',
                    },
                    {
                        label: t('job-manage'),
                        onClick: handleManageJobs,
                        variant: 'outlined',
                        'data-tour': 'manage-jobs-btn',
                    },
                ]}
                breadcrumbs={[
                    {
                        path: '/resume',
                        title: t('resume-list'),
                    },
                ]}
            />

            {/* Filters */}
            <Paper data-tour="resume-filter-bar">
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />
            </Paper>

            {/* Data table */}
            <Paper data-tour="resume-data-table">
                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={resumes}
                        rowKey={(row) => String(row.id)}
                        resizable
                        size="small"
                        autoWidth
                        actions={actions}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search-resume', {
                                    defaultValue: 'Tìm kiếm ứng viên...',
                                }),
                                tourId: 'resume-search',
                            },
                            settings: {
                                show: true,
                                storageKey: 'resume-list',
                                tourId: 'resume-settings',
                                actionComponents: [
                                    <Button
                                        key="export"
                                        size="small"
                                        variant="outlined"
                                        startIcon={
                                            <DownLoadIcons className="w-4 h-4" />
                                        }
                                        onClick={handleExport}
                                    >
                                        {t('download')}
                                    </Button>,
                                ],
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default List
